import { SettingConst } from '@faire/web-api--source/types';

/**
 * Used to configure which sessions will be recorded in Hotjar.
 */
export const RECORD_SESSION_HOTJAR = 'RECORD_SESSION_HOTJAR' as SettingConst<
  'RECORD_SESSION_HOTJAR',
  boolean,
  'MAKER' | 'RETAILER' | 'HELP_CENTER'
>;
